import Conveniado from '../../../services/conveniado-service';
import Account from '../../../services/account';

export default{
  data() {
    return {
      vouchers: [],
      loading: undefined,
      nome: undefined,
      sobrenome: undefined,
      nomeCliente: undefined,
      contractId: undefined,
      salesOrderId: undefined
    }
  },
  
  methods: {
    print() {
      var prtContent = document.getElementById("comprovante");
      var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
      WinPrint.document.write(prtContent.innerHTML);
      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    }
  },
  mounted(){
      $('[data-toggle="tooltip"]').tooltip();
      
      this.contractId = this.$route.params.contractId;

      let req = {
        salesOrderId: this.$route.params.orderId
      }

      //Identifica o Nome e Sobrenome do Cliente
      this.loading = Account.getUserByMoveMaisId(this.$route.params.moveMaisId).then(resp => {

        if (resp.user.person != null){
          this.nome        = resp.user.person.name;
          this.sobrenome   = resp.user.person.lastName;
          this.nomeCliente = this.nome + ' ' + this.sobrenome;

        }else{
          this.nomeCliente = resp.user.company.companyTradeName;
        }

      }).catch(err => {
        
      });

      // Lista todos os vouchers referentes ao pedido
      this.loading = Conveniado.listaVouchersConveniadoComStatus(req).then(resp => {
        this.vouchers = resp.listaVouchersConveniado;     
        
      }).catch(err => {
        
      });
    }
}



// WEBPACK FOOTER //
// ./src/pages/account/request/conveniado-voucher.js